
const digest = '02d5fcfdd37c5a8d5dfcedd5338036cef174ebabad8b4cd69cc6d2df920a8509';
const classes = {"wrapper":"_wrapper_ab154_1","scrollWrapper":"_scrollWrapper_ab154_6","flatWrapper":"_flatWrapper_ab154_11"};
const css = `._wrapper_ab154_1 {
  height: 100%;
  overflow: hidden;
  padding-bottom: 130px;
}
._wrapper_ab154_1 ._scrollWrapper_ab154_6 {
  height: 100%;
  overflow-y: scroll;
}

._flatWrapper_ab154_11 {
  overflow: visible !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  